function onRecaptchaSuccess() {
    window.recaptchaSuccess = true
}

function onRecaptchaError() {
    window.recaptchaSuccess = false
}

function onRecaptchaResponseExpiry() {
    onRecaptchaError()
}

(function () {
    const initWebitel = () => {
        const script = document.createElement('script');
        script.src = 'https://webitel.cashx.lk/omni-widget/WtOmniWidget.umd.js';
        script.onload = function () {
            const body = document.querySelector('body');
            const widgetEl = document.createElement('div');
            widgetEl.setAttribute('id', 'wt-omnichannel-widget');
            body.appendChild(widgetEl);
            const config = {
                "view": {
                    "borderRadiusStyle": "rounded",
                    "lang": "en",
                    "btnOpacity": "1",
                    "logoUrl": "https://loanplus.lk/wp-content/uploads/2023/12/webital-logo-light.png",
                    "accentColor": "hsl(248, 72%, 63%)",
                    "position": "right"
                },
                "chat": {
                    "url": "wss://webitel.cashx.lk/chat/vdkefcirqdvdndsfzmrdtpesswymmgt"
                },
                "alternativeChannels": {
                    "whatsapp": "https://wa.me/+94774411122",
                    "email": "info@loanplus.lk"
                }
            };
            const app = new WtOmniWidget('#wt-omnichannel-widget', config);
        };
        document.head.appendChild(script);
        const link = document.createElement('link');
        link.href = 'https://webitel.cashx.lk/omni-widget/WtOmniWidget.css';
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.media = 'screen,print';
        document.head.appendChild(link);
    }

    const initFingerprint = () => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@3/dist/fp.min.js';
        script.onload = function () {
            FingerprintJS.load().then(fp => {
                fp.get().then(result => {
                    window.fingerPrint = result;
                });
            });
        };
        document.head.appendChild(script);
    }

    const initRecaptcha = () => {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        document.head.appendChild(script);
    }

    let hasRun = false

    function logEvent(event) {
        if (!hasRun) {
            initWebitel()

            if (CALCULATOR_TYPE === 'registration') {
                initFingerprint()

                initRecaptcha()
            }
        }

        hasRun = true
    }

    window.addEventListener('mousemove', logEvent);
    window.addEventListener('touchstart', logEvent);
}());
